




























import Vue from 'vue';
import massVuex from '../../vuex/common';
import SelectRemarkBox from '../../../customer/components/remarks/SelectRemarkBox.vue';

export default Vue.extend({
  mixins: [massVuex],
  components: {
    SelectRemarkBox,
  },
  data() {
    return {
      hasSelectedRemarks: false,
      showRemarkBox: false,
    };
  },
  methods: {
    confirmRemarkBox(remarks: any) {
      this.$store.commit('UPDATE_BROADCAST_REMARK', remarks);
      this.hasSelectedRemarks = true;
      this.showRemarkBox = false;
    },
  },
});
